import { createEntityAdapter } from '@reduxjs/toolkit';
import { CommanderStatusAPIResponse } from '../CommanderStatusAPI.model';

export const CommanderStatusAdapter =
  createEntityAdapter<CommanderStatusAPIResponse>({
    selectId: (deviceStatus: CommanderStatusAPIResponse) =>
      deviceStatus.deviceID,
  });
